import ajax from 'Site/js/util/ajax.fetch';
import doggingForm from 'Dogging/js/page/dogging-form';
import dropdownDirective from 'Site/directive/dropdown';
import store from 'Site/js/store';
import PaginationValidation from 'Site/js/mixin/pagination.input.check';
import PromptSignup from 'Site/js/mixin/prompt.signup';
import Vue from 'vue';

function dogging() {
    if (document.getElementById('dogging-county-body')) {
        new Vue({ /* eslint no-new: 0 */
            el: '#dogging-county-body',
            name: 'doggingCounty',
            store,
            directives: {
                dropdown: dropdownDirective
            },
            methods: {
                confirmDelete(text, url, redirect) {
                    store.dispatch('showConfirm', {
                        text,
                        callback() {
                            ajax.delete(url).then(() => {
                                window.location = redirect;
                            });
                        }
                    });
                }
            },
            mixins: [PaginationValidation, PromptSignup]
        });
    }
}

export default {
    'dogging-county': dogging,
    'dogging-county-paginator': dogging,
    'dogging-county-location': () => {
        if (document.querySelector('#dogging-location-buttons')) {
            new Vue({ /* eslint no-new: 0 */
                el: '#dogging-location-buttons',
                name: 'doggingLocation',
                store,
                methods: {
                    confirmDelete(text, url, redirect) {
                        store.dispatch('showConfirm', {
                            text,
                            callback() {
                                ajax.delete(url).then(() => {
                                    window.location = redirect;
                                });
                            }
                        });
                    }
                }
            });
        }
    },
    'dogging-submit': doggingForm,
    'dogging-county-location-edit': doggingForm
};
